import React from 'react'

// Mapbox needs NO global preload (each <Map> loads its own GL context with the
// access token passed via props), so this component is now a simple passthrough.
// It keeps its name/export and the GOOGLE_MAPS_KEY prop for call-site
// compatibility, but no longer gates children behind a JS-API loader.
const GoogleMapsLoader = ({ children }) => {
  return <>{children}</>
}
export default GoogleMapsLoader
